import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';


@Pipe({
  name: 'difftime'
})
export class DiffTimePipe implements PipeTransform {

  transform(value: string, args: any): any {
    const oneDay = 24 * 60 * 60 * 1000;
    const end: any = dayjs(value);
    const today: any = new Date();
    const diffTime = new Date(Math.abs(end - today));
    if (args === 'days') {
      return Math.round(Math.abs((end - today) / oneDay));
    }
    return diffTime.getHours();
  }

}
